module.exports = __webpack_public_path__ + "static/img/103476.99c0247a.png";